import React from 'react';
import PropTypes from 'prop-types';
import Loader from '../Loader/Loader';

const Button = ({ 
    children, 
    variant = 'primary',
    alternate = false,
    size = 'medium', 
    disabled = false,
    unsetHeight = false,
    loading = false,
    icon = null,
    type = "button",
    style = {},
    index = null,
    classes = "",
    ...props 
}) => (
    <button key={index} className={`btn ${!children ? "icon-only" : ""} figtree-bold ${loading ? "hide-text" : ""} ${variant} ${alternate ? "alternate" : ""} ${size} ${unsetHeight ? "unset-height" : ""} ${children ? "text" : ""} ${children ? (size === "small" ? "caption" : size === "medium" ? "caption" : size === "large" ? "paragraph" : "") : ""} ${classes}`} {...props} style={style} type={type} disabled={disabled}>
        {children}
        {icon && (
            <div className={`icon ${icon} ${loading ? "hidden" : ""}`} />
        )}
        <Loader loading={loading} />
    </button>
);

Button.propTypes = {
    variant: PropTypes.oneOf(['primary', 'secondary', 'yellow', 'grey', 'transparent']),
    alternate: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    icon: PropTypes.string,
    index: PropTypes.string,
    classes: PropTypes.string,
    children: PropTypes.node
};

export default Button;